export default function () {
  return {
    visibleColumns: [
      'coa',
      'name',
      'category_1',
      'category_2',
      'category_3',
      'category_4'
    ],

    columns: [
      {
        name: 'coa_no',
        label: 'No. COA',
        align: 'left',
        field: row => {
          return row.coa_no
            ? `<strong class="text-primary">${row.coa_no}</strong>`
            : '-'
        },
        sortable: true
      },
      {
        name: 'name',
        label: 'Nama',
        align: 'left',
        field: 'name',
        sortable: true
      },
      {
        name: 'type_1',
        field: 'type_1',
        label: 'Tipe 1',
        align: 'left'
      },
      {
        name: 'type_2',
        field: 'type_2',
        label: 'Tipe 2',
        align: 'left'
      }
    ]
  }
}
